import { useContext } from "react";
import { Datagrid, DateField, List, TextField } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const AcademicPeriodList = (props) => {

    const appContext = useContext(AppContext)

    return (
        <List exporter={false} bulkActionButtons={false}
            sort={{ field: 'start_at', order: 'DESC' }}
            title={'Períodos letivos'}
            {...props}
        >
            <Datagrid rowClick={'edit'}>
                <TextField source="name" label={'Nome'} />
                {appContext.profile.name === ProfileEnum.SUPERADMIN && <TextField source="institution_branch.institution.name" label={'Instituição'} />}
                {(appContext.profile.name === ProfileEnum.SUPERADMIN || appContext.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && <TextField source="institution_branch.name" label={'Unidade'} />}
                <DateField source="start_at" label={'Data de início'} />
                <DateField source="end_at" label={'Data de término'} />
            </Datagrid>
        </List>
    )
}

export default AcademicPeriodList;